/**
 * @file 公式编辑器 item
 */
import { Divider } from '@seiue/ui'
import React from 'react'
import { InlineMath } from 'react-katex'
import styled from 'styled-components'

import { FormulateItem } from './types'

/**
 * 公式编辑器 item
 *
 * @param props - props
 * @param props.item - 公式数据
 * @param props.onItemClick - value Change
 * @param props.value - value
 * @returns Item
 */
export const Item: React.FC<{
  item: FormulateItem[]
  onItemClick: (val: string) => void
  value: string
}> = ({ item, onItemClick, value }) => {
  return (
    <Wrapper onClick={(e) => e.stopPropagation()}>
      {item.map((d, dindex) => (
        <div key={dindex}>
          <ItemTypeName>{d.label}</ItemTypeName>
          <Divider />
          <ItemWrapper>
            {d.items.map((i, index) => (
              <ItemLabel
                key={`${dindex}-${index}`}
                onClick={() => {
                  onItemClick(value + i)
                }}
              >
                <InlineMath math={i} />
              </ItemLabel>
            ))}
          </ItemWrapper>
          <Divider />
        </div>
      ))}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  padding: 12px;
  background-color: #fff;
  border: 1px solid ${(props) => props.theme.border.greyLight};
  border-top: none;
  border-radius: 0px 0px 4px 4px;
  height: 200px;
  overflow: auto;
`

const ItemLabel = styled.div`
  background-color: ${(props) => props.theme.background._3};
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  color: ${(props) => props.theme.text._1};
  &&& {
    .katex-display {
      margin: 0;
    }
  }
`

const ItemWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 4px;
  margin: 8px 0;
`

const ItemTypeName = styled.div`
  margin: 6px 0;
`
